import CommandManager from '../managers/command-manager';
import elt from '../html/elt';
import logging from '../logging';

const log = logging('components');

/**
 * Dispatches a global CustomEvent when clicked. The type of the command can be
 * configured by the "action" attribute.
 */
export default class CommandSelect extends HTMLElement {

    select: HTMLSelectElement;

    constructor() {
        super();
        this.select = elt('select');
    }

    connectedCallback() {
        const select = this.select;

        if(this.hasAttribute('label')) {
            const labelString = this.getAttribute('label')

            const option = document.createElement('option');
            option.value = '~label';
            option.innerHTML = labelString;
            select.append(option);
        }

        const options = this.querySelectorAll('option');
        for(const option of options) {
            select.append(option);
        }


        select.addEventListener('change', () => {
            const
                action = this.getAttribute('action'),
                channel = this.getAttribute('channel') ?? 'app-command',
                choice = select.value;

            if(choice == '~label') {
                return;
            }

            log.debug(`CommandSelect.change ${action} ${choice}`);

            CommandManager.do(channel, action, choice);

            if(this.hasAttribute('label')) {
                this.select.value = '~label';
            }
        });

        this.append(this.select);
    }

    get value() {
        return (this.select as HTMLSelectElement).value;
    }
}
window.customElements.define('command-select', CommandSelect);
log.debug('Defined custom element <command-select>');
